import React, { useEffect, useCallback, useState, useRef, memo } from "react";
import Live from "./Live";
import Scheduled from "./Scheduled";
import Result from "./Result";
import "./cricket.m.css";

import axios from "axios";

function Cricket() {
  const isLoaded = useRef(false);

  const [data, setData] = useState(null);

  const loadData = async (callback) => {
    try {
      const baseUrl = "https://dmu-api.gulfnews.com/v2";
      const url = baseUrl + "/gn-feeds/cricket-data/multisport_cache_32_1_0_0530_en_4.json?" + new Date().getTime();
      const response = await axios.get(url);
      setData(response.data);
      if (callback) {
        callback(response.data);
      }
    } catch (error) {
      console.error("Error in loading data:", error);
    }
  };

  useEffect(() => {
    if (isLoaded.current) return;
    isLoaded.current = true;
    loadData((data) => {
      const matches = data.matches;
      const live = matches.filter((match) => match.event_state === "L");
      if (live.length) {
        setInterval(loadData, 10000);
      }
    });
    return () => {};
  }, []);

  if (!data) return null;
  const matches = data.matches;
  const live = matches.filter((match) => match.event_state === "L");
  const nextM = matches.filter((match) => match.event_state === "U");
  const res = matches.filter((match) => match.event_state === "R");
  return (
    <div styleName="cricketlive">
      {live.length ? (
        <Live liveData={live} />
      ) : nextM.length > 0 && res.length > 0 ? (
        <div styleName="flipper">
          <div styleName="front">
            <Result result={res} />
          </div>
          <div styleName="next">
            <Scheduled nextm={nextM} />
          </div>
        </div>
      ) : (
        <>
          {res.length > 0 && <Result result={res} />}
          {nextM.length > 0 && <Scheduled nextm={nextM} />}
        </>
      )}
    </div>
  );
}
export default memo(Cricket);
